import React, { useState, useEffect } from 'react';
import SoftwareLicenceService from './SoftwareLicenceService';
import Alert from 'react-bootstrap/Alert';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../common/AdvanceList';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import { Card, Table } from 'react-bootstrap';
import ActionButton from 'components/common/ActionButton';
import DirectoryService from '../directory/DirectoryService';
const SoftwareLicenceList = () => {
  const [licences, setLicences] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [refresh, setRefresh]   = useState(false);
  const [noDataToShow, setNoDataToShow] = useState(true);
  const navigate = useNavigate();
  const archiveLicence = (identifier, profileIdentifier) => {
    const profileLogged = DirectoryService.retrieveLoggedProfile();
    if (profileLogged.identifier === profileIdentifier) {
      //setShowErrorModal(false);
      SoftwareLicenceService.deleteSoftwareLicence(identifier)
        .then(doc => {
          console.log(doc);
          setRefresh(true);
        })
        .catch(error => console.error(error));
    } else {
      setShowErrorModal(true);
    }
  };
  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    setColumns(fieldsForList);

    SoftwareLicenceService.retrieveAllSoftwareLicenceByAccount()
      .then(data => {
        setLicences(data);
        setNoDataToShow(!licences.length > 0);
      })
      .catch(error => setError({ error: error.message }));
  }, [noDataToShow, refresh]);
  const buttonsConf = [
    {
      name: 'Add a new Software',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Create a new SoftwareLicence');
        navigate('/app/software-licences/create-form');
      }
    }
  ];
  const headerGenerated = useHeaderGenerator('Software', ' ', buttonsConf);
  return (
    <>
      {headerGenerated}

      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any SoftwareLicence to show. Let's create a new one!
        </Alert>
      )}
      {licences && (
        <Card>
          <Card.Body>
            <Card.Title>Software Licences</Card.Title>

        <Table bordered responsive>
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Licence Key</th>
              <th className={'text-end'} scope="col">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {licences.map(licence => {
              return (
                <tr key={licence.name}>
                  <td>
                    <a href={'/app/software-licences/' + licence.identifier}>
                      {licence.name}
                    </a>
                  </td>
                  <td>{licence.licenceKey}</td>
                  <td className="text-end">
                    <ActionButton
                      icon="trash-alt"
                      title="Remove"
                      variant="action"
                      className="p-0"
                      onClick={() =>
                        archiveLicence(licence.identifier, licence.profileIdentifier)
                      }
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        </Card.Body>
      </Card>
      )}
    </>
  );
};

export default SoftwareLicenceList;
